import {createApp} from "vue";
import {createI18n} from "vue-i18n";
import App from "@/App.vue";
import {createPinia} from "pinia";
import {searchPosts} from "@/fetch";
import {messages} from "@/locales";
import {initializeSessionStorage, loadMoreHandler, populateSettings, sessionStorageListener} from "@/utils";

const lang = document.documentElement.lang.split("_")[0];
const filters = document.getElementById(
    "dynamic-archive-filters"
) as HTMLElement;
const posts = document.getElementById("dynamic-archive-posts") as HTMLElement;

if (posts != undefined) {
    const type = posts.dataset.type;
    if (type != undefined) {
        // Create i18n instance with options
        const i18n = createI18n({
            legacy: false,
            locale: lang, // set locale
            fallbackLocale: "en", // set fallback locale
            messages, // set locale messages
        });

        const app = createApp(App);
        app.use(createPinia());
        app.use(i18n);

        initializeSessionStorage(type, lang)
        populateSettings(filters, posts);
        loadMoreHandler();
        sessionStorageListener();
        // Fetch default posts.
        searchPosts();

        app.mount(posts);
    }
}
